import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { db } from '../../firebase';
import { doc, onSnapshot } from 'firebase/firestore';
import './Billing.css';

const CheckoutSuccess = () => {
  const { user, loading: authLoading } = useAuth();
  const navigate = useNavigate();
  const [status, setStatus] = useState('confirming'); // 'confirming' | 'ready'

  // Wait for the webhook to update the user document with subscription data
  useEffect(() => {
    if (!user) return;

    const userRef = doc(db, 'users', user.uid);

    const unsubscribe = onSnapshot(userRef, (snapshot) => {
      if (snapshot.exists()) {
        const data = snapshot.data();
        const subStatus = data.subscriptionStatus;

        if (subStatus && ['active', 'trialing'].includes(subStatus)) {
          setStatus('ready');
          // Give user a moment to see the success message before redirecting
          setTimeout(() => navigate('/billing'), 2000);
        }
      }
    });

    // Timeout fallback — if webhook is slow, redirect after 10s anyway
    const timeout = setTimeout(() => {
      setStatus('ready');
      navigate('/billing');
    }, 10000);

    return () => {
      unsubscribe();
      clearTimeout(timeout);
    };
  }, [user, navigate]);

  useEffect(() => {
    if (!authLoading && !user) {
      navigate('/login');
    }
  }, [user, authLoading, navigate]);

  if (authLoading) return null;

  return (
    <div className="billing-container">
      <div className="billing-header" style={{ textAlign: 'center' }}>
        {status === 'confirming' ? (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>⏳</div>
            <h1 className="billing-title">Confirming your subscription…</h1>
            <p className="billing-subtitle">
              We're setting everything up. This usually takes just a few seconds.
            </p>
          </>
        ) : (
          <>
            <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>✅</div>
            <h1 className="billing-title">You're all set!</h1>
            <p className="billing-subtitle">
              Your subscription is active. Redirecting to your billing dashboard…
            </p>
          </>
        )}
      </div>
    </div>
  );
};

export default CheckoutSuccess;
